/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {NbAclOptions} from '@nebular/security';


/**
 * ACL options for existing roles
 * @see {@link https://akveo.github.io/nebular/docs/security/acl-configuration--usage#acl-configuration}
 */
export const ACL_OPTIONS: NbAclOptions = {
  accessControl: {
    ROLE_ACCOUNT: {
      view: ['authorized-block', 'base-price-block']
    },
    ROLE_SUB_ACCOUNT: {
      view: ['authorized-block', 'base-price-block']
    },
    ROLE_ANONYMOUS: {
      view: ['not-authorized-block']
    },
  }
};
